module.exports = __webpack_public_path__ + "img/badExample.bb3d53f4.png";